import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";

const DialogSaveInformationConfirmation = ({
	dialog, space, saveInformation
}) => {
	return (
		<DialogAlertAction
			variant="secondary"
			width="700px"
			toggleShow={dialog.toggle}
			show={dialog.value}
			title={`¿Deseas cambiar el estado de la reserva del espacio ${space.name}?`}
			content="Recuerda que al cambiar el estado de la reserva podrás visualizarla en la grilla.">
			<CustomButton
				variant="secondary"
				text="No, cancelar"
				width="140px"
				onClick={dialog.hide} />
			<CustomButton
				text="Sí, guardar"
				width="140px"
				onClick={saveInformation} />
		</DialogAlertAction>
	);
}

export default DialogSaveInformationConfirmation;